export default "__VITE_ASSET__CLBY5oW8__"